import axios from 'axios';
import { getAuthHeader } from './authApi';

export interface UserBetStat {
  user_id: number;
  first_name: string;
  last_name: string;
  count: number;
  is_current_user: boolean;
}

export interface UserPointsStat {
  user_id: number;
  first_name: string;
  last_name: string;
  points: number;
  is_current_user: boolean;
}

export interface MatchSuccessStat {
  match_id: string;
  match: string;
  success_pct: number;
}

export const getMostExactScoreCatches = async (): Promise<UserBetStat[]> => {
  try {
    const response = await axios.get('/api/fun-facts/most-exact-score-catches', {
      headers: getAuthHeader(),
    });
    return response.data.most_exact_score_catches || [];
  } catch (error) {
    console.error('Error fetching most exact score catches:', error);
    return [];
  }
};

export const getMostWinnerCatches = async (): Promise<UserBetStat[]> => {
  try {
    const response = await axios.get('/api/fun-facts/most-winner-catches', {
      headers: getAuthHeader(),
    });
    return response.data.most_winner_catches || [];
  } catch (error) {
    console.error('Error fetching most winner catches:', error);
    return [];
  }
};

export const getMostUpsetBonusCatches = async (): Promise<UserBetStat[]> => {
  try {
    const response = await axios.get('/api/fun-facts/most-upset-bonus-catches', {
      headers: getAuthHeader(),
    });
    return response.data.most_upset_bonus_catches || [];
  } catch (error) {
    console.error('Error fetching most upset bonus catches:', error);
    return [];
  }
};

export const getMostPointsLast6Games = async (): Promise<UserPointsStat[]> => {
  try {
    const response = await axios.get('/api/fun-facts/most-points-last-6-games', {
      headers: getAuthHeader(),
    });
    return response.data.most_points_last_6_games || [];
  } catch (error) {
    console.error('Error fetching most points last 6 games:', error);
    return [];
  }
};

export const getMostPerfectScores = async (): Promise<UserBetStat[]> => {
  try {
    const response = await axios.get('/api/fun-facts/most-perfect-scores', {
      headers: getAuthHeader(),
    });
    return response.data.most_perfect_scores || [];
  } catch (error) {
    console.error('Error fetching most perfect scores:', error);
    return [];
  }
};

export const getMostPointsFromGeneralBets = async (): Promise<UserPointsStat[]> => {
  try {
    const response = await axios.get('/api/fun-facts/most-points-from-general-bets', {
      headers: getAuthHeader(),
    });
    return response.data.most_points_from_general_bets || [];
  } catch (error) {
    console.error('Error fetching most points from general bets:', error);
    return [];
  }
};

export const getMatchesMostPoints = async (): Promise<MatchSuccessStat[]> => {
  try {
    const response = await axios.get('/api/fun-facts/matches-most-points', {
      headers: getAuthHeader(),
    });
    return response.data.matches_most_points || [];
  } catch (error) {
    console.error('Error fetching matches most points:', error);
    return [];
  }
};

export const getMatchesLeastPoints = async (): Promise<MatchSuccessStat[]> => {
  try {
    const response = await axios.get('/api/fun-facts/matches-least-points', {
      headers: getAuthHeader(),
    });
    return response.data.matches_least_points || [];
  } catch (error) {
    console.error('Error fetching matches least points:', error);
    return [];
  }
};

export const getGroupStageLeader = async (): Promise<UserPointsStat[]> => {
  try {
    const response = await axios.get('/api/fun-facts/group-stage-leader', {
      headers: getAuthHeader(),
    });
    return response.data.group_stage_leader || [];
  } catch (error) {
    console.error('Error fetching group stage leader:', error);
    return [];
  }
};

export const getKnockoutLeader = async (): Promise<UserPointsStat[]> => {
  try {
    const response = await axios.get('/api/fun-facts/knockout-leader', {
      headers: getAuthHeader(),
    });
    return response.data.knockout_leader || [];
  } catch (error) {
    console.error('Error fetching knockout leader:', error);
    return [];
  }
};
